import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import scss from "./Landing.module.scss";
import WithMotion from "../utils/withMotion";

const Landing = () => {
  const history = useHistory();
  const { squadSubmission } = useSelector((state: any) => state);
  const buttonText = squadSubmission ? "VIEW SCORE" : "GET STARTED";

  return (
    <main className={scss.main}>
      <h2 className={scss.selectCharacters}>
        BUILD THE BEST SQUAD,
        <br />
        GET BRAGGING RIGHTS,
        <br />
        AND BE ENTERED FOR A<br />
        CHANCE TO WIN.
      </h2>
      <p className={scss.prizes}>
        Win an Exclusive Signed DC Comic
        <br /> Book and 12-months of Access to
        <br /> DC Universe Infinite.
      </p>
      <button
        onClick={() => history.push("/sign-up")}
        className={`roundedButton ${scss.roundedButton}`}
      >
        {buttonText}
      </button>
      <p className={scss.sweepsTerms}>
        <b>NO PURCHASE NECESSARY.</b> Ends 11:59 pm PT on August 9, 2021. Open
        only to United States; 17+. 10 prizes are available to be won (ARV: US
        $84.99). Entries will not be judged. Winner will be randomly selected.
        Rules/odds/alt. method of entry:{" "}
        <span>
          <a
            className={scss.blueLink}
            href="https://www.imax.com/content/squad-rules"
            target="_blank"
            rel="noreferrer"
          >
            Official Rules
          </a>
        </span>
      </p>
    </main>
  );
};

export default WithMotion(Landing);
